module.exports = __webpack_public_path__ + "static/media/sou.0b28cc37.jpg";